import { useEffect, useState } from "react";
import { fetchProVenMappings, downloadProVenMappingsExcel } from "../Api/ViewProVenMapping";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const ViewProVenMapping = () => {
  const [mappings, setMappings] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loadMappings = async () => {
      try {
        const data = await fetchProVenMappings();
        setMappings(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Project-Vendor Mappings`);
      }
    };

    loadMappings();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadProVenMappingsExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Project_Vendor_Mappings.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Project-Vendor Mappings download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleCreateMapping = () => {
    navigate("/pro-ven-mapping");
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="list-title">View Project-Vendor Mappings</h2>
              <div>
                <Button 
                  variant="success" 
                  onClick={handleCreateMapping}
                  className="me-2"
                >
                  Create Project Vendor Mapping
                </Button>
                <Button 
                  className="generate-btn"
                  variant="primary" 
                  onClick={handleDownload}
                  disabled={isDownloading || mappings.length === 0}
                >
                  {isDownloading ? 'Downloading...' : 'Download Data'}
                </Button>
              </div>
            </div>

            {mappings.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Mapping ID</th>
                    <th>Project Code</th>
                    <th>Project Name</th>
                    <th>Vendor Code</th>
                    <th>Vendor Name</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Changed On</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {mappings.map((mapping, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{mapping.proVenID}</td>
                      <td>{mapping.projectCode}</td>
                      <td>{mapping.projectName}</td>
                      <td>{mapping.vendorCode}</td>
                      <td>{mapping.vendorName}</td>
                      <td>
                        {moment(mapping.createdOnDate).format('L')} at {mapping.createdOnTime}
                      </td>
                      <td>{mapping.createdBy}</td>
                      <td>
                        {mapping.changedOnDate ? 
                          `${moment(mapping.changedOnDate).format('L')} at ${mapping.changedOnTime}` : 
                          'Not changed'}
                      </td>
                      <td>{mapping.changedBy || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No project-vendor mappings found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewProVenMapping;